import React, { useEffect, useState } from 'react';
import { Alert, Box, MenuItem, TextField } from '@mui/material';
import { idOf } from './transferModel.mjs';

export default function TeamPicker({ api, context, value, onChange, disabled = false, exclude = '', size = 'small', inputClassName = '', menuClassName = 'transfers-menu' }) {
  const [competitions, setCompetitions] = useState([]);
  const [teams, setTeams] = useState([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const { provider, discipline, season } = context;
  const competition = value.competition || '';
  useEffect(() => {
    let live = true;
    setCompetitions([]); setError('');
    if (!provider || !discipline || !season) return;
    Promise.resolve().then(() => api.fetchCompetitions({ provider, discipline, season }))
      .then(r => { if (live) setCompetitions(r.data || []); })
      .catch(() => { if (live) setError('Impossible de charger les compétitions. Modifiez un filtre pour réessayer.'); });
    return () => { live = false; };
  }, [api, provider, discipline, season]);
  useEffect(() => {
    let live = true;
    setTeams([]); setError(''); setBusy(false);
    if (!competition || !provider || !discipline || !season) return;
    setBusy(true);
    Promise.resolve().then(() => api.fetchTeams({ provider, discipline, season, competition }))
      .then(r => { if (live) setTeams(r.data || []); })
      .catch(() => { if (live) setError('Impossible de charger les équipes. Sélectionnez à nouveau la compétition.'); })
      .finally(() => { if (live) setBusy(false); });
    return () => { live = false; };
  }, [api, provider, discipline, season, competition]);
  return <Box className="transfers-team-picker">
    {error && <Alert severity="error">{error}</Alert>}
    <Box className="transfers-fields-row">
      <TextField select fullWidth size={size} className={inputClassName} label="Compétition" value={competition}
        SelectProps={{ MenuProps: { className: menuClassName } }}
        disabled={disabled || !competitions.length} onChange={e => onChange({ competition: e.target.value, team: null })}>
        {competitions.map(c => <MenuItem key={idOf(c)} value={idOf(c)}>{c.name}</MenuItem>)}
      </TextField>
      <TextField select fullWidth size={size} className={inputClassName} label={busy ? 'Chargement…' : 'Équipe'} value={idOf(value.team)}
        SelectProps={{ MenuProps: { className: menuClassName } }}
        disabled={disabled || busy || !teams.length} onChange={e => onChange({ competition, team: teams.find(t => idOf(t) === e.target.value) })}>
        {teams.filter(t => idOf(t) !== idOf(exclude)).map(t => <MenuItem key={idOf(t)} value={idOf(t)}>{t.name}</MenuItem>)}
      </TextField>
    </Box>
  </Box>;
}
